import type {NodeSchedule} from 'src/types/node-schedule';
import type {SMSChatbotState} from 'src/types/sms-chatbot';
import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApiBff from 'src/utils/redux-api-bff';
import * as reduxApi from 'src/utils/redux-api-v2';
import {parseSMSChatbot} from 'src/utils/sms-chatbot';


export const RECEIVE_SMS_CHATBOT_INFO = 'sms-chatbot/receive';
export const UPDATE_SMS_CHATBOT_INFO = 'sms-chatbot/update';
export const UPDATE_NODE_SCHEDULE = 'sms-chatbot/update-node-schedule';
export const RESET = 'sms-chatbot/reset';

type UpdateSMSChatbotInfoPayload = Partial<SMSChatbotState>;

type ReceiveSMSChatbotInfoAction = {
  type: 'sms-chatbot/receive';
  payload: SMSChatbotState;
};

type UpdateSMSChatbotInfoAction = {
  type: 'sms-chatbot/update';
  payload: UpdateSMSChatbotInfoPayload;
};
type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE;
  payload: Partial<NodeSchedule>;
};
type ResetStateAction = {
  type: 'sms-chatbot/reset';
};

export type SMSChatbotAction =
  | ReceiveSMSChatbotInfoAction
  | UpdateSMSChatbotInfoAction
  | UpdateNodeScheduleAction
  | ResetStateAction;

export const reset = (): ResetStateAction => ({type: RESET});

export const receiveSMSChatbotNode = (
  payload: SMSChatbotState,
): ReceiveSMSChatbotInfoAction => ({
  type: RECEIVE_SMS_CHATBOT_INFO,
  payload,
});

export const updateSMSChatbotInfo = (
  payload: UpdateSMSChatbotInfoPayload,
): UpdateSMSChatbotInfoAction => ({
  type: UPDATE_SMS_CHATBOT_INFO,
  payload,
});
export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});

export const getSMSChatbotTaskNode: (node_id: string) => ThunkAction<unknown> =
  (node_id) => async (dispatch: Dispatch) => {
    const fetchedNodeResponse = await dispatch(
      reduxApiBff.get(`node/composite`, {
        node_id,
      }),
    );
    const parsedSmsNode = parseSMSChatbot(fetchedNodeResponse.body);
    return dispatch(updateSMSChatbotInfo(parsedSmsNode));
  };

// TODO: Seem like this action is not used anywhere.
export const getProvisionedPhoneNumbers: (
  id: string | number,
) => ThunkAction<unknown> = (id) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.get(`provisioned-phone`, {
      search_query: '',
      associated_with_category: String(true),
      category_id: String(id),
    }),
  );
};
